import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface AuthWrapperProps {
  children: React.ReactNode;
}

/**
 * AuthWrapper - Component that checks for JWT token expiration on every route change
 * Wraps around all routes and validates the JWT on each navigation action
 */
const AuthWrapper = ({ children }: AuthWrapperProps) => {
  const location = useLocation();
  const { checkTokenExpiration } = useAuth();

  useEffect(() => {
    // Run token expiration check whenever the route changes
    checkTokenExpiration();
  }, [location.pathname, checkTokenExpiration]);

  // Render children without affecting the UI
  return <>{children}</>;
};

export default AuthWrapper;
